export default __webpack_public_path__ + "static/media/stars.cb6ad4ef.svg";